import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { changeToken } from '../store';

function useAuthorization(token) {

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(changeToken(token));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    return {
        token
    };
}
export default useAuthorization;